export const environment = {
  production: true,
  base_url: 'https://api.strongbee.tech/',
  maps_api: 'AIzaSyCtAUdR-I7xENJ7CoQHURn1Ovhr7S16S58',
  deeplink_scheme: 'strongbee://',
  tiny_mce_api_key: 'pcscwinjq4bexc7mdtatafbx6sxqwlap16pr1yc417md9mn7',
  optionalModules: [],
  chat_url: "https://cms-strongbee.vercel.app/chat"
};
